'use client';

// Use 'force-dynamic' to enable environment-agnostic builds
export const dynamic = 'force-dynamic';

import ErrorPage from './error';

export default function GlobalErrorPage({ error }: { error: Error & { digest?: string } }) {
  return <ErrorPage error={error} />;
}
